import React, { memo } from "react";
import { useNavigate } from "react-router-dom";
import Icons from "../../components/icons";
import { ICONS } from "../../constants/icons.constants";
import styles from "./MobileHeader.module.scss";

const MobileHeader = ({ title, showBack, rightAction }) => {
  const navigate = useNavigate();

  return (
    <div className={styles.header}>
      {showBack ? (
        <button className={styles.backBtn} onClick={() => navigate(-1)}>
          <Icons type={ICONS.BACK_ARROW} />
        </button>
      ) : (
        <div className={styles.spacer} />
      )}
      <h1 className={styles.title}>{title}</h1>
      {rightAction || <div className={styles.spacer} />}
    </div>
  );
};

export default memo(MobileHeader);
